import { Box, Typography } from '@mui/material';
import {
  selectCompletionStepBodyText,
  selectShowMileageText,
  vehicleFormHooks,
} from 'app-components/flux/vehicle/vehicleForm';
import { useVehicleTracking } from 'app-components/flux/vehicle/vehicleTracking';
import QButton from 'components/QButton';
import QIllustration from 'components/QIllustration';
import React from 'react';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  compledContainer: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  dismissButton: {
    margin: theme.spacing(3, 4),
    padding: theme.spacing(1, 7),
    borderRadius: theme.spacing(4),
  },
  carIllustration: {
    marginTop: theme.spacing(-1),
  },
}));

const MileageText = () => {
  const shouldShowMileageText = vehicleFormHooks.useSelector(selectShowMileageText);

  if (shouldShowMileageText) {
    return (
      <Typography variant='bodyRegular' textAlign='center' mt={2}>
        Your mileage will update over time to reflect typical driving. You can change this in{' '}
        <Typography component='span' variant='bodyMedium'>
          Settings &gt; Accounts
        </Typography>
        .
      </Typography>
    );
  } else {
    return null;
  }
};

export const CompletionStep = ({ handleDialogClose }: { handleDialogClose: () => void }) => {
  const { classes } = useStyles();

  const { value: accountName } = vehicleFormHooks.useField('name');
  const bodyText = vehicleFormHooks.useSelector(selectCompletionStepBodyText);
  const { trackOnce } = useVehicleTracking();

  return (
    <Box className={classes.compledContainer}>
      <QIllustration name='CarAdded' size='xl' className={classes.carIllustration} />
      <Box px={4}>
        <Typography variant='bodyMedium' textAlign='center'>
          {`${accountName}`}
        </Typography>
        <Typography variant='bodyRegular' textAlign='center'>
          {bodyText}
        </Typography>
        <MileageText />
      </Box>
      <QButton
        variant='contained'
        onClick={() => {
          handleDialogClose();
          trackOnce('kbbFinish');
        }}
        className={classes.dismissButton}
      >
        Dismiss
      </QButton>
    </Box>
  );
};
